export const getters = {
  // 银行账户名称
  accName(state) {
    return state.accName;
  },
  // 用户类型
  userType(state) {
    return state.userType;
  },
  isChecked(state) {
    return state.checked;
  },
  companyLegalInfo(state) {
    return state.companyLegalInfo;
  },
  isLegal(state) {
    return state.isLegal;
  },
  assignorMobile(state) {
    return state.assignorMobile;
  },
  personMobile(state) {
    return state.personMobile;
  }
};
